import React, { useState, Fragment } from "react";
import Alert from "../layout/Alert";
import { setAlert } from "../../action/alert";
import { useDispatch, useSelector } from "react-redux";
import { Tabs, Tab, Box, CircularProgress } from "@material-ui/core";
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { uploadMatterCD, fetchMatterCD, deleteMatterCD } from "../../action/matterCD";
import DeleteIcon from "@material-ui/icons/Delete";
import UploadCDForm from './UploadCDForm'
import GetCDForm from "./GetCDForm"
import ResponsiveContentWrapper from "../layout/ResponsiveContentWrapper";

const useStyles = makeStyles({
  selectInput: {
    height: "3rem",
    width: "100%",
  },
  selectValues: {
    width: "100%",
  },
  activeTab: {
    border: "1px solid #bdbdbd",
    backgroundColor: "#e0e0e0",
    textTransform: "capitalize",
  },
  nonActiveTab: {
    border: "none",
    backgroundColor: "none",
    textTransform: "capitalize",
  },
});

const MatterCD = () => {
  const [activeTab, setActiveTab] = useState(0);
  const classes = useStyles();

  React.useEffect(() => {
    const switchToUploadTabHandler = () => setActiveTab(0);
    window.addEventListener("switchToUploadTab", switchToUploadTabHandler);
    return () => {
      window.removeEventListener("switchToUploadTab", switchToUploadTabHandler);
    };
  }, []);

  return (
    <ResponsiveContentWrapper>
      <div className="row">
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          TabIndicatorProps={{ style: { backgroundColor: "#bdbdbd" } }}
          style={{ marginTop: "20px" }}
        >
          <Tab
            label="Upload CD"
            className={activeTab === 0 ? classes.activeTab : classes.nonActiveTab}
          />
          <Tab
            label="GET CD"
            className={activeTab === 1 ? classes.activeTab : classes.nonActiveTab}
          />
        </Tabs>
        <div hidden={activeTab !== 0}>
          <UploadCDForm activeTab={activeTab} />
        </div>
        <div hidden={activeTab !== 1}>
          <GetCDForm />
        </div>
      </div>
    </ResponsiveContentWrapper>
  );
};

export default MatterCD;
